import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_220: DocMigration = {
  maxSchemaVersion: "0.0.220",
  description: "Migrate wall end framing type to the new roof framing settings",
  apply(json: any) {
    if (json.roofs) {
      const { roofs } = json;

      for (const roofId in roofs) {
        const roof = roofs[roofId];
        const { roofSettings = {} } = roof;
        const { startFramingType, endFramingType } = roofSettings;

        let addRoofFramingSettings = false;
        const roofFramingSettings = {};

        if (startFramingType) {
          roofFramingSettings["startFramingType"] = startFramingType;
          delete roofSettings.startFramingType;

          addRoofFramingSettings = true;
        }

        if (endFramingType) {
          roofFramingSettings["endFramingType"] = endFramingType;
          delete roofSettings.endFramingType;

          addRoofFramingSettings = true;
        }

        if (addRoofFramingSettings) {
          json.roofs[roofId] = {
            ...roof,
            roofFramingSettings,
          };
        }
      }
    }

    return json;
  },
};

export default migration_0_0_220;
